<template>
    <div>
        <div class="com-problem block">
            <div class="com-problem-wrapper container">
                <div class="com-problem__header com-title">你是否面临这样的问题</div>
                <div class="com-problem__con">
                    <ul>
                        <li><label>快递堆积成山，缺乏好的系统进行包裹管理，头疼！</label></li>	
                        <li><label>已经买了系统，却无法满足日益增长的业务需求，心塞！</label></li>
                        <li><label>定制开发费用高，20w+开发费让人望而却步，无力！</label></li>
                        <li><label>缺乏直观财务表，excel表格管理收支乱得一团糟，头晕！</label></li>
                        <li><label>在用线路成本高，更优惠的线路价格轮不到我，泪奔！</label></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="com-problem__footer">
            别担心，有问题找有寄！
            <div class="block">
                <img src="@/assets/arrow.png"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-problem'
}
</script>

<style lang="less" scoped>
    .com-problem {
        background: url('~@/assets/man.png') no-repeat center bottom;
        background-size: 3.7rem;
        &__con {
            padding: 0 .5rem;
            li {
                margin-bottom: .2rem;
                label {
                    display: inline-block;
                    box-shadow: 0 0 0.1rem #cad1e2;
                    padding: .12rem .3rem;
                    border-radius: .3rem;
                    font-size: .26rem;
                    background: #fff;
                    color: #6c81a9;
                }
                &:nth-child(1) {
                    padding-left: 1.2rem;
                }
                &:nth-child(2)  {
                    padding-right: 1.2rem;
                }
                &:nth-child(3)  {
                    padding-right: 0.6rem;
                }
                &:nth-child(4)  {
                    padding-right: 0.6rem;
                }
                &:nth-child(2n) {
                    text-align: right;
                }
            }
        }
        &__footer {
            background: #40bc66;
            text-align: center;
            color: #fff;
            font-size: .41rem;
            line-height: 1.2rem;
            .block {
                height: 0.4rem;
                img {
                    width: .8rem;
                    z-index: 1;
                }
            }
        }
    }
    @media only screen and (max-width: 800px) {
        .com-problem {
            &__con {
                li {
                    margin-bottom: .3rem;
                    label {
                        font-size: .32rem;
                    }
                    &:nth-child(n) {
                        padding: 0;
                    }
                }
            }
        }
    }
</style>

